import { render, staticRenderFns } from "./wajue-folder.vue?vue&type=template&id=29f527b4&scoped=true&"
import script from "./wajue-folder.vue?vue&type=script&lang=ts&"
export * from "./wajue-folder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f527b4",
  null
  
)

export default component.exports